module.exports = __webpack_public_path__ + "img/dna_gif_hover.da4c9607.gif";